let routes = [
    // 氢能
    {
        path: 'hydrogen',
        name: '氢能',
        component: () => import('@/views/hydrogen/index'),
    },
    {
        path: 'hydrogen/twoPage/industry',
        name: '氢能行业动态二级页',
        component: () => import('@/views/hydrogen/twoPage/industry')
    },
    {
        path: 'hydrogen/industry',
        name: '氢能行业动态详情页',
        component: () => import('@/views/hydrogen/detail/industry')
    },
    {
        path: 'hydrogen/twoPage/price',
        name: '氢能价格二级页',
        component: () => import('@/views/hydrogen/twoPage/price')
    },
    {
        path: 'hydrogen/price',
        name: '氢能价格详情页',
        component: () => import('@/views/hydrogen/detail/price')
    },
    {
        path: 'hydrogen/priceXin',
        name: '氢能价格详情页',
        component: () => import('@/views/hydrogen/detail/priceXin')
    },
    {
        path: 'hydrogen/twoPage/comment',
        name: '氢能市场点评二级页',
        component: () => import('@/views/hydrogen/twoPage/comment')
    },
    {
        path: 'hydrogen/comment',
        name: '氢能市场点评详情页',
        component: () => import('@/views/hydrogen/detail/comment')
    },
    {
        path: 'hydrogen/twoPage/report',
        name: '氢能研究报告二级页',
        component: () => import('@/views/hydrogen/twoPage/report')
    },
    {
        path: 'hydrogen/twoPage/rate',
        name: '氢能重点企业开工率二级页',
        component: () => import('@/views/hydrogen/twoPage/rate')
    },
    {
        path: 'hydrogen/rate',
        name: '氢能重点企业开工率详情页',
        component: () => import('@/views/hydrogen/detail/rate')
    },
    {
        path: 'hydrogen/twoPage/yield',
        name: '氢能重点企业产量二级页',
        component: () => import('@/views/hydrogen/twoPage/yield')
    },
    {
        path: 'hydrogen/yield',
        name: '氢能重点企业产量详情页',
        component: () => import('@/views/hydrogen/detail/yield')
    },
    {
        path: 'hydrogen/twoPage/property',
        name: '氢能产业链二级页',
        component: () => import('@/views/hydrogen/twoPage/property')
    },
    {
        path: 'hydrogen/property',
        name: '氢能产业链详情页',
        component: () => import('@/views/hydrogen/detail/property')
    },
    {
        path: 'hydrogen/twoPage/station',
        name: '加氢站二级页',
        component: () => import('@/views/hydrogen/twoPage/station')
    },
    {
        path: 'hydrogen/station',
        name: '加氢站详情页',
        component: () => import('@/views/hydrogen/detail/station')
    },
    {
        path: 'hydrogen/twoPage/battery',
        name: '燃料电池二级页',
        component: () => import('@/views/hydrogen/twoPage/battery')
    },
    {
        path: 'hydrogen/battery',
        name: '燃料电池详情页',
        component: () => import('@/views/hydrogen/detail/battery')
    },
    {
        path: 'hydrogen/twoPage/project',
        name: '新建项目二级页',
        component: () => import('@/views/hydrogen/twoPage/project')
    },
    {
        path: 'hydrogen/project',
        name: '新建项目详情页',
        component: () => import('@/views/hydrogen/detail/project')
    },
    {
        path: 'hydrogen/twoPage/plan',
        name: '区域规划二级页',
        component: () => import('@/views/hydrogen/twoPage/plan')
    },
    {
        path: 'hydrogen/plan',
        name: '区域规划详情页',
        component: () => import('@/views/hydrogen/detail/plan')
    },
    {
        path: 'hydrogen/twoPage/month',
        name: '加氢站月报二级页',
        component: () => import('@/views/hydrogen/twoPage/month')
    },
    {
        path: 'hydrogen/twoPage/database',
        name: '项目数据库二级页',
        component: () => import('@/views/hydrogen/twoPage/database')
    },
    {
        path: 'hydrogen/database',
        name: '项目数据库详情页',
        component: () => import('@/views/hydrogen/detail/database')
    },
    {
        path: 'hydrogen/databaseWrite',
        name: '项目绿氢文本详情页',
        component: () => import('@/views/hydrogen/detail/databaseWrite')
    },
    {
        path: 'hydrogen/twoPage/exit',
        name: '项目进出口二级页',
        component: () => import('@/views/hydrogen/twoPage/exit')
    },
    {
        path: 'hydrogen/exit',
        name: '项目进出口详情页',
        component: () => import('@/views/hydrogen/detail/exit')
    },
    {
        path: 'hydrogen/map',
        name: '地图详情页',
        component: () => import('@/views/hydrogen/detail/map')
    },
]

export default routes;
